import {useContext, useEffect, useState} from "react";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import UserContext from "./UserContext.jsx";
import {CardHeader, Typography, Box, Chip, Link, Snackbar, Alert, Tabs, Tab} from "@mui/material";
import Button from "@mui/material/Button";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from "dayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import { InstagramEmbed } from "react-social-media-embed";
import { AdminCalendarPage } from "./AdminCalendarPage.jsx";

const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;

const NoInstagramPosts = () => <Card>
    <CardHeader title={"No Instagram Posts Found"} />
    <CardContent>
        No Instagram posts with unverified dates found
    </CardContent>
</Card>

const SelectEventDateStep = (props) => {
    const { date, setDate} = props;
    return <Box>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* (v) => setDate(v.format("YYYY-MM-DD")) */}
            <DateCalendar
                value={dayjs(date + "T12:00:00")}
                onChange={(v) =>setDate(v.format("YYYY-MM-DD"))}
                sx={{margin: 0}}
                />
            </LocalizationProvider>
        </Box>
}

export const AdminPage = () => {

    const user = useContext(UserContext)
    const [instagramPosts, setInstagramPosts] = useState([])
    const [loading, setLoading] = useState(true)
    const [currentPostIndex, setCurrentPostIndex] = useState(0)
    const [venueMap, setVenueMap] = useState(new Map())
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState("")
    const [snackbarSeverity, setSnackbarSeverity] = useState("success")
    const [tabValue, setTabValue] = useState("calendar")

    const showSnackbar = (message, severity = "success") => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    }

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    }

    const loadVenues = async () => {
        const token = window.localStorage.getItem("authToken");
        try {
            const response = await fetch(`${BACKEND_HOST}/venues?filters[market][$eq]=local&pagination[pageSize]=100`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const result = await response.json();
            const venues = result.data || result;
            
            // Build map with venueKey as key, venue as value
            const map = new Map();
            venues.forEach(venue => {
                const venueData = venue.attributes || venue;
                if (venueData.venueKey) {
                    map.set(venueData.venueKey, venueData);
                }
            });
            setVenueMap(map);
        } catch (error) {
            console.error('Error loading venues:', error);
        }
    }

    const loadInstagramPosts = () => {
        const token = window.localStorage.getItem("authToken");
        return fetch(`${BACKEND_HOST}/instagram-inbounds?filters[linkerStatus][$eq]=inbound&populate=*`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(res => {
            // Handle Strapi v4 response format
            const posts = res.data || res;
            setInstagramPosts(posts);
            setLoading(false);
        })
        .catch(error => {
            console.error('Error loading Instagram posts:', error);
            setLoading(false);
        });
    }

    useEffect(() => {
        loadVenues();
        loadInstagramPosts();
    }, [])

    const saveHandler = (postDocumentId, date, venueKey) => {
        const token = window.localStorage.getItem("authToken");
        
        // Format date as YYYY-MM-DD
      
        
        fetch(`${BACKEND_HOST}/instagram-inbounds/${postDocumentId}`, {
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                data: { 
                    finalDate: date,
                    venueKey: venueKey,
                    linkerStatus: "verified"
                }
            })
        })
        .then(res => {
            const success = res.status === 200;
            showSnackbar(success ? "Saved Successfully" : "Failed", success ? "success" : "error");
            if (success) {
                loadInstagramPosts();
                setCurrentPostIndex(0);
            }
        })
        .catch(error => {
            console.error('Error saving post:', error);
            showSnackbar("Failed", "error");
        });
    }

    const markAsInvalidHandler = (postDocumentId) => {
        const token = window.localStorage.getItem("authToken");
        fetch(`${BACKEND_HOST}/instagram-inbounds/${postDocumentId}`, {
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                data: { 
                    linkerStatus: "hidden" 
                }
            })
        })
        .then(res => {
            const success = res.status === 200;
            showSnackbar(success ? "Marked as Invalid" : "Failed", success ? "success" : "error");
            if (success) {
                loadInstagramPosts();
                setCurrentPostIndex(0);
            }
        })
        .catch(error => {
            console.error('Error marking post as invalid:', error);
            showSnackbar("Failed", "error");
        });
    }

    const InstagramPostCards = () => {

        
        const [showFullCaption, setShowFullCaption] = useState(false);
        const [date, setDate] = useState(instagramPosts[currentPostIndex] ? instagramPosts[currentPostIndex].standardDate: null);
        
        
        if (loading) {
            return <Card>
                <CardContent>
                    <Typography>Loading...</Typography>
                </CardContent>
            </Card>
        }

        if (instagramPosts.length === 0) {
            return <NoInstagramPosts />
        }

        // Show only current post
        const post = instagramPosts[currentPostIndex];
        if (!post) return <NoInstagramPosts />;

   
        
        
         // Caption display logic
        const caption = post.caption || 'No caption';
        const shouldTruncate = caption.length > 300;
        const displayCaption = shouldTruncate && !showFullCaption 
            ? caption.slice(0, 300) + '...' 
            : caption;
        
        
        
        // Helper function to get day of week
        const getDayOfWeek = (dateString) => {
            if (!dateString) return '';
            try {
                const date = new Date(dateString + "T12:00:00");
                const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                return days[date.getDay()];
            } catch {
                return '';
            }
        };
        
        const dayOfWeek = getDayOfWeek(post.standardDate);
        const postedDayOfWeek = getDayOfWeek(post.timestamp);
        
       
        
        return (
            <>
                {/* Navigation Header */}
                <Card sx={{ mb: 2 }}>
                    <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Button 
                                variant="outlined"
                                onClick={() => setCurrentPostIndex(Math.max(0, currentPostIndex - 1))}
                                disabled={currentPostIndex === 0}
                            >
                                Previous
                            </Button>
                            <Typography variant="h6">
                                {currentPostIndex + 1} of {instagramPosts.length}
                            </Typography>
                            <Button 
                                variant="outlined"
                                onClick={() => setCurrentPostIndex(Math.min(instagramPosts.length - 1, currentPostIndex + 1))}
                                disabled={currentPostIndex === instagramPosts.length - 1}
                            >
                                Next
                            </Button>
                        </Box>
                    </CardContent>
                </Card>

                {/* Current Post */}
                <Card key={post.id} sx={{ mb: 2 }}>
                    <CardContent>
                        <Box sx={{ mb: 2, display: 'flex', flexDirection: 'row', gap: 4 }}>
                            <Box p={2}>
                                <Typography variant="body2" color="text.secondary">
                                    <strong>Posted:</strong> {post.timestamp || 'Unknown date'} {postedDayOfWeek ? ` (${postedDayOfWeek})` : ''}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    <strong>Selected:</strong> {date || 'Unknown date'} {dayOfWeek ? ` (${dayOfWeek})` : ''}
                                </Typography>
                                <Box sx={{ mt: 2, mb: 2 }}>
                                    <SelectEventDateStep date={date} setDate={setDate} />
                                </Box>
                                {post.venueKey && (
                                    <Typography variant="body2" color="text.secondary">
                                        <strong>Venue:</strong> {venueMap.get(post.venueKey)?.name || post.venueKey}
                                    </Typography>
                                )}
                                <Typography variant="body2" color="text.secondary" gutterBottom>
                                    Status: <Chip 
                                        label={post.inferredDateVerified ? "Verified" : "Needs Review"} 
                                        color={post.inferredDateVerified ? "success" : "warning"}
                                        size="small"
                                    />
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, m: 2 }}>
                                    <Button 
                                        variant="contained"
                                        color="success"
                                        onClick={() => {
                                            saveHandler(
                                                post.documentId || post.id, 
                                                date, 
                                                post.venueKey
                                            );
                                            // Auto-advance to next post after saving
                                            if (currentPostIndex < instagramPosts.length - 1) {
                                                setCurrentPostIndex(currentPostIndex + 1);
                                            }
                                        }}
                                    >
                                        Save
                                    </Button>
                                    <Button 
                                        variant="outlined"
                                        color="error"
                                        onClick={() => {
                                            markAsInvalidHandler(post.documentId || post.id);
                                            // Auto-advance to next post after marking invalid
                                            if (currentPostIndex < instagramPosts.length - 1) {
                                                setCurrentPostIndex(currentPostIndex + 1);
                                            }
                                        }}
                                    >
                                        Mark as Invalid
                                    </Button>
                                </Box>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    {displayCaption}
                                    {shouldTruncate && (
                                        <Link
                                            component="button"
                                            variant="body2"
                                            onClick={() => setShowFullCaption(!showFullCaption)}
                                            sx={{ ml: 1, cursor: 'pointer' }}
                                        >
                                            {showFullCaption ? 'Show less' : 'Show more'}
                                        </Link>
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                <InstagramEmbed url={`https://instagram.com/p/${post.shortCode}`} width={"300px"} />
                            </Box>
                        </Box>
                    </CardContent>
                    
                </Card>
            </>
        )
    }

    return (
        <div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
                    <Tab label="Calendar" value="calendar" />
                    <Tab label="Status" value="status" />
                    <Tab label="Moderation" value="moderation" />
                </Tabs>
            </Box>

            {tabValue === "calendar" && (
                <AdminCalendarPage />
            )}

            {tabValue === "status" && (
                <Card>
                    <CardHeader title={"Status"} />
                    <CardContent>
                        <Typography variant="body2">
                            System status overview
                        </Typography>
                    </CardContent>
                </Card>
            )}

            {tabValue === "moderation" && (
                <>
                    <Card>
                        <CardHeader title={"Instagram Posts - Date Verification"} />
                        <CardContent>
                            <Typography variant="body2">
                                Review Instagram posts where the inferred date needs verification
                            </Typography>
                        </CardContent>
                    </Card>
                    <br/>
                    <InstagramPostCards />
                </>
            )}
            
            {/* Snackbar for notifications */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert 
                    onClose={handleSnackbarClose} 
                    severity={snackbarSeverity}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}